import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { applyMiddleware, createStore, bindActionCreators } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import thunk from 'redux-thunk';
import app from './reducers';
import { historyMiddleware } from './Middlewares/History.middleware';
import { add as addToCart, bulkAdd as bulkAddToCart, reorder, update as updateCart } from './Actions/Cart.action';
import { remove as removePdfItem } from './Actions/Pdf.action';

import QuantityInput from './Components/QuantityInput';
import IconWithTooltip from "./Components/IconWithTooltip";

import PdfButtonContainer from './Containers/PdfButton.container';
import MiniCartContainer from './Containers/MiniCart.container';
import PdfFolderContainer from './Containers/PdfFolder.container';
import PdfButtonCreatePdfContainer from './Containers/PdfButtonCreatePdf.container';
import QuickSearchContainer from './Containers/QuickSearch.container';
import NavigationContainer from './Containers/Navigation.container';
import SettingsBannerContainer from './Containers/SettingsBanner.container';
import FacetedSearchContainer from './Containers/FacetedSearch.container';
import FacetedSearchCompactContainer from './Containers/FacetedSearchCompact.container';
import LanguageSelectorContainer from "./Containers/LanguageSelector.container";
import DocumentLink from "./Components/DocumentLink";
import DynamicComponent from './Components/DynamicComponent';

import * as events from './events';

import { translate } from './Services/translation';
import OrderHistoryFilter from "./Components/OrderHistoryFilter";


window.__litium = window.__litium || {};
const preloadState = window.__litium.preloadState || {};
// use the parent page's store if possible, so the iframe will share the same store with the parent context.
// this to makes for example the Reorder button in My Page page to update the state and reload the mini cart
// when reorder action happens.
const store = window.__litium.store = window.__litium.store || (window.parent.__litium && window.parent.__litium.store)
    || createStore(app, preloadState, composeWithDevTools(applyMiddleware(thunk, historyMiddleware)));
window.__litium = {
    ...window.__litium,
    reduxActions: bindActionCreators({ addToCart, bulkAddToCart, reorder, updateCart, removePdfItem }, store.dispatch),
    events: {
        onAddToCartButtonClick: (articleNumber, quantityFieldId = null) => {
            window.__litium.reduxActions.addToCart({ 
                articleNumber, 
                quantity: quantityFieldId ? document.getElementById(quantityFieldId).value : 1
            });
        },
        onBulkAddToCartButtonClick: (articleNumbers, quantityFieldId = null) => {
            window.__litium.reduxActions.bulkAddToCart({ 
                articleNumbers, 
                quantity: quantityFieldId ? document.getElementById(quantityFieldId).value : 1
            });
        },
        onReorderClick: (orderid) => {
            if (orderid) {
                window.__litium.reduxActions.reorder({orderid});
            }
        },
        onUpdateCartClick: (rowSystemId, quantity) => {
            window.__litium.reduxActions.updateCart(rowSystemId, quantity);
        },
        onRemovePdfItemClick: (variantArticleNumber) => {
            window.__litium.reduxActions.removePdfItem(variantArticleNumber);
        },
    },
    bootstrapComponents: () => {
        // bootstrap React components, in case the HTML response we receive from the server
        // has React components. renderReact performs only an update on previous rendered
        // components and only mutate the DOM as necessary to reflect latest React element.
        bootstrapComponents();
    },
    cache: {}, // for storing cache data for current request
};

const registeredContainers = [];
const renderReact = (element, container, callback) => {
    registeredContainers.push(container);
    ReactDOM.render(element, container, callback);
}

window.onunload = () => {
    // make sure components are unmounted, redux's listener are unsubscribed
    // to fix issue with iframe navigation in IE
    registeredContainers.forEach(container => {
        ReactDOM.unmountComponentAtNode(container);
    });
}

window._hideBrokenImages = function() {
    const replace = function() {this.src='/ui/images/Logo_AuraLight_alt2.png'}
    document.querySelectorAll('img').forEach(function(img){
        img.onerror = replace;
    });
}

const bootstrapComponents = () => {
    // _hideBrokenImages();

    if (document.getElementById("miniCart")) {
        renderReact(
            <Provider store={store}>
                <MiniCartContainer/>
            </Provider>,
            document.getElementById("miniCart")
        );
    }
    if (document.getElementById("pdfFolder")) {
        renderReact(
            <Provider store={store}>
                <PdfFolderContainer />
            </Provider>,
            document.getElementById("pdfFolder")
        );
    }
    if (document.getElementById("pdfButtonCreatePdf")) {
        renderReact(
            <Provider store={store}>
                <PdfButtonCreatePdfContainer />
            </Provider>,
            document.getElementById("pdfButtonCreatePdf")
        );
    }
    if (document.getElementById("quickSearch")) {
        renderReact(
            <Provider store={store}>
                <QuickSearchContainer/>
            </Provider>,
            document.getElementById("quickSearch")
        );
    }
    if (document.getElementById("navbar")) {
        renderReact(
            <Provider store={store}>
                <NavigationContainer/>
            </Provider>,
            document.getElementById("navbar")
        );
    }
    if (document.getElementById("facetedSearch")) {
        var filterDiv = document.getElementById("facetedSearch")
        var productId = filterDiv.dataset.productId;

        renderReact(
            <Provider store={store}>
                <FacetedSearchContainer productId={productId} />
            </Provider>,
            document.getElementById("facetedSearch")
        );
    }
    if (document.getElementById("energy-label")) {
        var energyElement = document.getElementById("energy-label")
        var {imageUrl, imageAlt, labelImageUrl, labelImageAlt} = energyElement.dataset;
        const EnergyLabel =  DynamicComponent({
            loader: () => import('./Components/EnergyLabel')
        });

        renderReact(
            <Provider store={store}>
                <EnergyLabel imageUrl={imageUrl} imageAlt={imageAlt} labelImageUrl={labelImageUrl} labelImageAlt={labelImageAlt} />
            </Provider>,
            energyElement
        );
    }
    if (document.getElementById("facetedSearchCompact")) {
        var filterDiv = document.getElementById("facetedSearch")
        var productId = filterDiv.dataset.productId;
        renderReact(
            <Provider store={store}>
                <FacetedSearchCompactContainer productId={productId}/>
            </Provider>,
            document.getElementById("facetedSearchCompact")
        );
    }
    if (document.getElementById("settingsBanner")) {
        renderReact(
            <Provider store={store}>
                <SettingsBannerContainer />
            </Provider>,
            document.getElementById("settingsBanner")
        );
    }

    //if (document.getElementById("globalNotification")) {
    //    renderReact(
    //        <Provider store={store}>
    //            <NotificationContainer/>
    //        </Provider>,
    //        document.getElementById("globalNotification")
    //    );
    //}
    if (document.getElementById("languageSelector")) {
        renderReact(
            <Provider store={store}>
                <LanguageSelectorContainer currentAsIcon={true}/>
            </Provider>,
            document.getElementById("languageSelector")
        );
    }

    if(document.getElementById("languageSelectorFooter")) {
        renderReact(
            <Provider store={store}>
                <LanguageSelectorContainer currentAsIcon={false}/>
            </Provider>,
            document.getElementById("languageSelectorFooter")
        );
    }

    if (document.getElementById('myPagePersons')) {
        const PersonList =  DynamicComponent({
            loader: () => import('./Containers/PersonList.container')
        });
        renderReact(
            <Provider store={store}>
                <PersonList />
            </Provider>,
    document.getElementById('myPagePersons')
        );
    }
    if (document.getElementById('myPageAddresses')) {
        const AddressList = DynamicComponent({
            loader: () => import('./Containers/AddressList.container')
        });
        renderReact(
            <Provider store={store}>
                <AddressList />
            </Provider>,
    document.getElementById('myPageAddresses')
        );
    }
    if (document.getElementById('checkout')) {
        const Checkout = DynamicComponent({
            loader: () => import('./Containers/Checkout.container')
        });
        renderReact(
            <Provider store={store}>
                <Checkout />
            </Provider>,
    document.getElementById('checkout')
        );
    }

    if (document.getElementById('punchout-checkout')) {
        const PunchoutCheckout = DynamicComponent({
            loader: () => import('./Containers/PunchoutCheckout.container')
        });
        renderReact(
            <Provider store={store}>
                <PunchoutCheckout />
            </Provider>,
            document.getElementById('punchout-checkout')
        );
    }

    if (document.querySelectorAll(".js-product-images").length > 0) {
        const ImageGallery = DynamicComponent({
            loader: () => import('./Containers/ImageGallery.container')
        });
        const rootElements = document.querySelectorAll('.js-product-images');
        Array.from(rootElements).forEach((rootElement) => {
            const images = Array.from(rootElement.querySelectorAll('a')).map(img => ({ src: img.dataset.src, alt: img.dataset.alt }));
            const thumbnails = Array.from(rootElement.querySelectorAll('a img')).map(img => ({ src: img.src }));
            const premium = rootElement.querySelector('.js-premium-badge');
            if (images.length != 0) {
                renderReact(
                    <Provider store={store}>
                        <ImageGallery images={images} thumbnails={thumbnails} premium={premium} />
                    </Provider>,
                    rootElement
                );
            }
        });
    }

    if (document.querySelectorAll(".slider.simple").length > 0) {
        const Slider = DynamicComponent({
            loader: () => import("./Components/Slider")
        });
        Array.from(document.querySelectorAll(".slider.simple")).forEach((slider) => {
            const values = [...slider.querySelectorAll(".slider__block")].map(block => {
                return ({
                    image: block.dataset.image,
                    url: block.dataset.url,
                    text: block.dataset.text,
                    alt: block.dataset.alt
                });
            });
            if (values.length > 0) {
                renderReact(<Slider values={values}/>, slider);
            }
        });
    }

    if (document.querySelectorAll(".slider.hero").length > 0) {
        const HeroImages = DynamicComponent({
            loader: () => import("./Components/HeroImages")
        });
        Array.from(document.querySelectorAll(".slider.hero")).forEach((heroImages) => {
            const values = [...heroImages.querySelectorAll(".slider__block")].map(block => {
                return ({
                    title: block.dataset.title,
                    text: block.dataset.text,
                    linkText: block.dataset.linktext,
                    linkUrl: block.dataset.linkurl,
                    image: block.dataset.image,
                    alt: block.dataset.alt
                });
            });
            if (values.length > 0) {
                renderReact(<HeroImages values={values} />, heroImages);
            }
        });
    }

    if(document.querySelectorAll(".row--inner.pages-preview-carousel__container").length > 0) {
        const PagesPreviewCarousel = DynamicComponent({
            loader: () => import("./Components/PagesPreviewCarousel")
        });

        Array.from(document.querySelectorAll(".row--inner.pages-preview-carousel__container")).forEach((pagesPreviewCarousel) => {

            const blockHeading = pagesPreviewCarousel.dataset.blockheading; 
            const cards = [...pagesPreviewCarousel.querySelectorAll(".page-preview")].map(block => {
                return ({
                    title: block.dataset.title,
                    description: block.dataset.description,
                    url: block.dataset.url,
                    imageUrl: block.dataset.imageurl
                });
            });
            if (cards.length > 0) {
                renderReact(<PagesPreviewCarousel cards={cards} blockHeading={blockHeading} />, pagesPreviewCarousel);
            }
        });
    }

    if (document.querySelectorAll('.pdf-button').length > 0) {
        Array.from(document.querySelectorAll('.pdf-button')).forEach((button) => {
            const { articleNumber, quantityFieldId, href, cssClass, label } = button.dataset;
            let active = false;
            let pdfItems = preloadState.pdfFolder.pdfItems;

            if (pdfItems && pdfItems.length > 0) {
                active = pdfItems.includes(articleNumber);
            }

            renderReact(
                <Provider store={store}>
                    <PdfButtonContainer {...{ label, articleNumber, quantityFieldId, href, cssClass, active }} />
                </Provider>,
                button
            );
        });
    }

    if (document.querySelectorAll('buy-button').length > 0) {
        const BuyButton = DynamicComponent({
            loader: () => import('./Containers/BuyButton.container')
        });
        Array.from(document.querySelectorAll('buy-button')).forEach((button) => {
            const { articleNumber, quantityFieldId, href, cssClass, label } = button.dataset;
            renderReact(
                <Provider store={store}>
                    <BuyButton {...{ label, articleNumber, quantityFieldId, href, cssClass }} />
                </Provider>,
                button
            );
        });
    }

    if (document.querySelectorAll('reorder-button').length) {
        const ReorderButton = DynamicComponent({
            loader: () => import('./Containers/ReorderButton.container')
        });
        Array.from(document.querySelectorAll('reorder-button')).forEach((button) => {
            const { cssClass, articles, title, label } = button.dataset;
            renderReact(
                <Provider store={store}>
                    <ReorderButton {...{ label, title, cssClass, articles }} />
                </Provider>,
                button
            );
        });
    }

    if (document.querySelectorAll('quantity-input').length) {
        document.querySelectorAll('quantity-input').forEach((input) => {
            const { quantityFieldId, unitsInBox, soldAsBox, popoverPlacement } = input.dataset;

            renderReact(
                <Provider store={store}>
                    <QuantityInput {...{ quantityFieldId, unitsInBox, soldAsBox, popoverPlacement }}/>
                </Provider>,
                input
            );
        });
    }

    if (document.querySelectorAll('icon-with-tooltip').length) {
        document.querySelectorAll('icon-with-tooltip').forEach((element) => {
            const { text, position, icon, extraClass, color } = element.dataset;

            renderReact(
                <Provider store={store}>
                    <IconWithTooltip {...{ text, position, icon, extraClass, color }}/>
                </Provider>,
                element
            );
        });
    }

    if (document.querySelectorAll('order-history-filter').length) {
        document.querySelectorAll('order-history-filter').forEach((element) => {
            const { searchPhrase, showOnlyMyOrders, businessCustomer, approverRole, listUrl } = element.dataset;

            renderReact(
                <Provider store={store}>
                    <OrderHistoryFilter {...{ searchPhrase, showOnlyMyOrders, businessCustomer, approverRole, listUrl }}/>
                </Provider>,
                element
            );
        });
    }

    if (document.querySelectorAll('document-link').length) {
        document.querySelectorAll('document-link').forEach((element) => {
            let { reference, name, icon, invoiceDate, download } = element.dataset;

            download = !!parseInt(download);

            renderReact(
                <Provider store={store}>
                    <DocumentLink {...{ reference, name, icon, invoiceDate, downloadEnabled: download }}/>
                </Provider>,
                element
            );
        });
    }

    events.init();
}

bootstrapComponents();
